const REQUIRED_FILTER_KEYS = ['term', 'speed', 'bundled'];

export const hasAllFilters = filters =>
    REQUIRED_FILTER_KEYS.every(
        key => Array.isArray(filters[key]) && filters[key].length > 0
    );

/** TSB modal only has Term and Bundled filters (no Speed); require those two to fetch offers. */
export const hasRequiredFiltersForTSB = filters =>
  Array.isArray(filters.term) &&
  filters.term.length > 0 &&
  Array.isArray(filters.bundled) &&
  filters.bundled.length > 0;